import React from "react";
import "../../stylesheets2025/Contact.css";

const Contact = () => {
    return (
        <div className="contact-container">
            <h1 className="contact-heading">Contact Us</h1>
            <p className="contact-text">
                For more information or any queries, please reach out to us:
            </p>

            <div className="contact-card">
                <div className="contact-row">
                    <strong>Email:</strong>
                    <a href="mailto:sanket@ecovillage.org.in">sanket@ecovillage.org.in</a>
                </div>

                <div className="contact-row">
                    <strong>Phone:</strong>
                    <div className="contact-list">
                        <div className="contact-item">
                            <a href="tel:9226516929">+91 9226516929</a>
                            <span>GEV School of Sustainability</span>
                        </div>

                        <div className="contact-item">
                            <a href="tel:7013088683">+91 7013088683</a>
                            <span>Himani Muppalla</span>
                        </div>

                        <div className="contact-item">
                            <a href="tel:7841957147">+91 7841957147</a>
                            <span>Pavan Muttepawar</span>
                        </div>
                    </div>
                </div>

                <div className="contact-row">
                    <strong>Address:</strong>
                    <p>Govardhan School of Sustainability, India</p>
                </div>
            </div>

        </div>
    );
};

export default Contact;
